const CloseIcon = () => {
    return <svg width="12" height="12" fill="none" xmlns="http://www.w3.org/2000/svg" id="close-icon"
        className="sc-giYgFv deECce"><path d="M7.446 5.973l4.36 4.36c.116.117.116.246 0 .386l-.81.809c-.14.117-.269.117-.386 0l-.738-.774L6.25 7.168l-4.359 4.36c-.117.117-.246.117-.387 0l-.808-.809c-.117-.14-.117-.27 0-.386l4.36-4.36-4.36-4.36c-.117-.116-.117-.245 0-.386l.808-.809c.141-.117.27-.117.387 0l4.36 4.36L10.61.418c.117-.117.246-.117.387 0l.808.809c.117.14.117.27 0 .387l-.773.738-3.586 3.621z"
            fill="#115CC4">
        </path>
    </svg>

}

export default CloseIcon;